import { SET_PROJECT_DETAILS, SET_PROJECT_LOADING, SET_PROJECT_ERROR, SET_INTAKE_PROJECT_DETAILS } from '../actionTypes/projectActionTypes';

// Action to set project details in Redux
export const setProjectDetails = (projectDetails: any) => ({
  type: SET_PROJECT_DETAILS,
  payload: projectDetails,
});

export const setIntakeProjectDetails = (IntakeProjectDetails: any) => ({
  type: SET_INTAKE_PROJECT_DETAILS,
  payload: IntakeProjectDetails,
});
// Action to set the loading state
export const setProjectLoading = (isLoading: boolean) => ({
  type: SET_PROJECT_LOADING,
  payload: isLoading,
});

// Action to handle errors
export const setProjectError = (error: string) => ({
  type: SET_PROJECT_ERROR,
  payload: error,
});
